import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import API_BASE_URL from '../config';
import {
    Container,
    Box,
    TextField,
    Button,
    Typography,
    Link,
    Alert
} from '@mui/material';

const Register = () => {
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (password !== confirmPassword) {
            setError('Les mots de passe ne correspondent pas');
            return;
        }

        try {
            const response = await axios.post(`${API_BASE_URL}/api/register`, {
                username,
                email,
                password
            });
            localStorage.setItem('token', response.data.token);
            navigate('/chat');
        } catch (error) {
            setError(error.response?.data?.error || 'Une erreur est survenue');
        }
    };

    return (
        <Container component="main" maxWidth="xs">
            <Box
                sx={{
                    marginTop: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    bgcolor: '#1a1a1a',
                    p: 4,
                    borderRadius: 2
                }}
            >
                <Typography component="h1" variant="h5" sx={{ color: '#ffffff' }}>
                    Inscription
                </Typography>
                {error && (
                    <Alert severity="error" sx={{ width: '100%', mt: 2 }}>
                        {error}
                    </Alert>
                )}
                <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1, width: '100%' }}>
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="username"
                        label="Nom d'utilisateur"
                        name="username"
                        autoComplete="username"
                        autoFocus
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                    borderColor: '#2a2a2a',
                                },
                                '&:hover fieldset': {
                                    borderColor: '#3a86ff',
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: '#3a86ff',
                                },
                            },
                            '& .MuiInputLabel-root': {
                                color: '#888888',
                            },
                            '& .MuiOutlinedInput-input': {
                                color: '#ffffff',
                            },
                        }}
                    />
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="email"
                        label="Adresse email"
                        name="email"
                        autoComplete="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                    borderColor: '#2a2a2a',
                                },
                                '&:hover fieldset': {
                                    borderColor: '#3a86ff',
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: '#3a86ff',
                                },
                            },
                            '& .MuiInputLabel-root': {
                                color: '#888888',
                            },
                            '& .MuiOutlinedInput-input': {
                                color: '#ffffff',
                            },
                        }}
                    />
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label="Mot de passe"
                        type="password"
                        id="password"
                        autoComplete="new-password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                    borderColor: '#2a2a2a',
                                },
                                '&:hover fieldset': {
                                    borderColor: '#3a86ff',
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: '#3a86ff',
                                },
                            },
                            '& .MuiInputLabel-root': {
                                color: '#888888',
                            },
                            '& .MuiOutlinedInput-input': {
                                color: '#ffffff',
                            },
                        }}
                    />
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="confirmPassword"
                        label="Confirmer le mot de passe"
                        type="password"
                        id="confirmPassword"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                    borderColor: '#2a2a2a',
                                },
                                '&:hover fieldset': {
                                    borderColor: '#3a86ff',
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: '#3a86ff',
                                },
                            },
                            '& .MuiInputLabel-root': {
                                color: '#888888',
                            },
                            '& .MuiOutlinedInput-input': {
                                color: '#ffffff',
                            },
                        }}
                    />
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{
                            mt: 3,
                            mb: 2,
                            bgcolor: '#3a86ff',
                            '&:hover': {
                                bgcolor: '#2b76ef',
                            },
                        }}
                    >
                        S'inscrire
                    </Button>
                    <Link href="/login" variant="body2" sx={{ color: '#888888' }}>
                        {"Vous avez déjà un compte ? Connectez-vous"}
                    </Link>
                </Box>
            </Box>
        </Container>
    );
};

export default Register; 